export default __webpack_public_path__ + "static/hari2-fe1b75f846d956fe9f4aaaab65d72430.jpg";